var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { keyframes } from "@mui/material";
var pulse = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% { transform: scale(1); opacity: 0.75; }\n  70% { transform: scale(2.5); opacity: 0; }\n  100% { transform: scale(1); opacity: 0; }\n"], ["\n  0% { transform: scale(1); opacity: 0.75; }\n  70% { transform: scale(2.5); opacity: 0; }\n  100% { transform: scale(1); opacity: 0; }\n"])));
export var footerStyles = {
    wrapper: {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height: "31px",
        backgroundColor: "#0a0a0a",
        borderTop: "1px solid #222",
        zIndex: 1000,
        pl: { md: "74px", xs: 1 },
        "@media (max-width: 374px)": {
            pl: 0,
        },
    },
    innerContainer: {
        maxWidth: "1920px",
        mx: "auto",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: 2, lg: 3 },
        overflowX: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
        "@media (max-width: 374px)": {
            px: 0.35,
            justifyContent: "space-evenly",
            gap: 0,
            overflowX: "hidden",
        },
    },
    section: {
        display: "flex",
        alignItems: "center",
        gap: { xs: 1.5, md: 2 },
        flexShrink: 0,
        "@media (max-width: 374px)": {
            display: "contents",
        },
    },
    item: {
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        color: "#888",
        fontSize: "0.75rem",
        cursor: "pointer",
        textDecoration: "none",
        fontFamily: "var(--default-font)",
        transition: "color 0.2s",
        whiteSpace: "nowrap",
        "&:hover": { color: "#fff" },
        "& .MuiTypography-root": { fontFamily: "inherit" },
        "@media (max-width: 374px)": {
            gap: 0.35,
            flexShrink: 1,
        },
    },
    hideOnMobile: {
        display: { xs: "none", md: "flex" },
        alignItems: "center",
    },
    hideOnTablet: {
        display: { xs: "none", lg: "flex" },
        alignItems: "center",
    },
    liveDot: {
        width: 8,
        height: 8,
        backgroundColor: "#00e676",
        borderRadius: "50%",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        boxShadow: "0 0 4px #00e676",
        "&::after": {
            content: '""',
            position: "absolute",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: "#00e676",
            animation: "".concat(pulse, " 2s cubic-bezier(0, 0, 0.2, 1) infinite"),
        },
    },
    toggleGroup: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#1a1a1a",
        borderRadius: "4px",
        p: "2px",
        flexShrink: 0,
        "@media (max-width: 374px)": {
            flexShrink: 1,
        },
    },
    toggleBtn: function (active) { return ({
        px: 1,
        py: 0.2,
        fontSize: "0.65rem",
        borderRadius: "2px",
        cursor: "pointer",
        color: active ? "#fff" : "#71717a",
        bgcolor: active ? "#27272a" : "transparent",
        fontFamily: "var(--default-font)",
        fontWeight: 500,
        minWidth: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease-in-out",
        "@media (max-width: 374px)": {
            minWidth: "44px",
            px: 0.7,
        },
    }); },
    socialWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        lineHeight: 0,
        "& img": {
            width: 16,
            height: 16,
            filter: "grayscale(1) brightness(0.5)",
            transition: "0.2s",
        },
        "&:hover img": { filter: "grayscale(0) brightness(1.5)" },
    },
    socialIcon: {
        fontSize: 16,
        color: "#888",
        cursor: "pointer",
        transition: "color 0.2s",
        "&:hover": { color: "#fff" },
    },
    quantaIconWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 16,
        height: 16,
        flexShrink: 0,
        "& img": {
            width: "100%",
            height: "100%",
            borderRadius: "50%",
        },
    },
};
var templateObject_1;
